import { render, staticRenderFns } from "./Polls.vue?vue&type=template&id=bee20338&"
import script from "./Polls.vue?vue&type=script&lang=js&"
export * from "./Polls.vue?vue&type=script&lang=js&"
import style0 from "./Polls.vue?vue&type=style&index=0&id=bee20338&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports